import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo } from 'react';
import { triggerNotificationsAPICallFailed, triggerNotificationsAPICallSucceeded, useCreateFireAnalyticsFromTrigger } from '@atlassian/notification-common';
import { useFetchService } from '../use-fetch-service';
import fetchGroupNotifications from '../utils/group-notifications-client';
import { RequestExpand } from '../utils/inbox-client/types';
export var useGroupNotificationsClient = function useGroupNotificationsClient(_ref) {
  var locale = _ref.locale,
    filters = _ref.filters,
    expand = _ref.expand;
  var fireNotificationsLoaded = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallSucceeded);
  var fireNotificationsFailedToLoad = useCreateFireAnalyticsFromTrigger(triggerNotificationsAPICallFailed);
  var withContent = expand === RequestExpand.CONTENT;
  var notificationsRequest = useCallback(function (request) {
    return fetchGroupNotifications(_objectSpread(_objectSpread({}, filters), {}, {
      expand: expand,
      locale: locale,
      continuationToken: request.continuationToken,
      limit: request.limit,
      groupId: request.groupId
    })).then(function (r) {
      fireNotificationsLoaded('/notification-groups/id/notifications', {
        withContent: withContent,
        limit: request.limit
      });
      return r;
    }).catch(function (e) {
      fireNotificationsFailedToLoad('/notification-groups/id/notifications', e.code, {
        withContent: withContent,
        limit: request.limit
      });
      throw e;
    });
  }, [filters, expand, locale, withContent, fireNotificationsFailedToLoad, fireNotificationsLoaded]);

  // Memoise initialData otherwise it causes an fetchData to be recreated each time the hook runs.
  var initialData = useMemo(function () {
    return {
      args: {
        filters: filters,
        limit: 8,
        groupId: ''
      },
      data: {
        notifications: []
      }
    };
  }, [filters]);
  var _useFetchService = useFetchService(notificationsRequest, initialData, 'group-notifications-client'),
    loadingState = _useFetchService.loadingState,
    error = _useFetchService.error,
    data = _useFetchService.data,
    fetchData = _useFetchService.fetchData;
  return {
    loadingState: loadingState,
    error: error,
    data: data,
    fetchData: fetchData
  };
};